var _defs, _rect, _rect2, _path, _path2, _ellipse, _path3, _path4, _path5, _path6, _path7, _ellipse2, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUnfollowmonkey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 192.3 147.67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#D\xE9grad\xE9_sans_nom_4);}.cls-2{fill:url(#D\xE9grad\xE9_sans_nom_4-2);}.cls-3{fill:#fff;}.cls-4{fill:#e24b9c;}.cls-5{fill:url(#D\xE9grad\xE9_sans_nom_4-3);}.cls-6{fill:url(#D\xE9grad\xE9_sans_nom_4-4);}.cls-7{fill:none;}.cls-8{fill:url(#linear-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_4",
    x1: 16.22,
    y1: 71.34,
    x2: 16.22,
    y2: 154.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2e22ac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#3123ac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#3b25ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#4c29a9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#642ea7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#8335a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#a83ea1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#d4489d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e24b9c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_4-2",
    x1: 176.08,
    y1: 71.34,
    x2: 176.08,
    y2: 154.99,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_4-3",
    x1: 71.12,
    y1: 18.76,
    x2: 71.12,
    y2: 85.96,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_4-4",
    x1: 122.81,
    y1: 18.76,
    x2: 122.81,
    y2: 85.96,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 96.15,
    y1: 1.87,
    x2: 96.15,
    y2: 146.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2e22ac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e24b9c"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.79,
    y: 112.84,
    width: 30.84,
    height: 34.83,
    rx: 10.01
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 160.66,
    y: 112.84,
    width: 30.84,
    height: 34.83,
    rx: 10.01
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M13.71,66.67c0,9.35,4.9,17.07,11.22,18.12A82.58,82.58,0,0,1,24.45,76a79.74,79.74,0,0,1,4.71-27.12,9,9,0,0,0-2.74-.43C19.4,48.43,13.71,56.6,13.71,66.67Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M82,92.83C82,94.59,84.29,96,87.15,96s5.18-1.43,5.18-3.19S90,89.65,87.15,89.65,82,91.07,82,92.83Z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 105.15,
    cy: 92.83,
    rx: 5.19,
    ry: 3.19
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M167.37,84.79c6.32-1.05,11.22-8.77,11.22-18.12,0-10.07-5.69-18.24-12.7-18.24a9.13,9.13,0,0,0-2.75.43,80.07,80.07,0,0,1,4.23,35.93Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M85.1,66.65a7.74,7.74,0,0,1-8-13.21,14,14,0,1,0,8,13.21Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M85.1,66.65a7.74,7.74,0,0,1-8-13.21,14,14,0,1,0,8,13.21Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M122.83,80.08a14,14,0,0,0,14-13.43,7.74,7.74,0,0,1-8-13.21,14,14,0,1,0-6,26.64Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M122.83,80.08a14,14,0,0,0,14-13.43,7.74,7.74,0,0,1-8-13.21,14,14,0,1,0-6,26.64Z"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 105.15,
    cy: 92.83,
    rx: 5.19,
    ry: 3.19
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M122.83,80.08a14,14,0,0,0,14-13.43,7.74,7.74,0,0,1-8-13.21,14,14,0,1,0-6,26.64Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M82,92.83C82,94.59,84.29,96,87.15,96s5.18-1.43,5.18-3.19S90,89.65,87.15,89.65,82,91.07,82,92.83Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M85.1,66.65a7.74,7.74,0,0,1-8-13.21,14,14,0,1,0,8,13.21Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M13.71,66.67c0,9.35,4.9,17.07,11.22,18.12A82.58,82.58,0,0,1,24.45,76a79.74,79.74,0,0,1,4.71-27.12,9,9,0,0,0-2.74-.43C19.4,48.43,13.71,56.6,13.71,66.67Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M165.89,48.43a9.13,9.13,0,0,0-2.75.43,80.07,80.07,0,0,1,4.23,35.93c6.32-1.05,11.22-8.77,11.22-18.12C178.59,56.6,172.9,48.43,165.89,48.43Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M165.89,35.85a22.94,22.94,0,0,0-8,1.45C145.39,15,122.42,0,96.15,0S46.92,15,34.43,37.3a22.92,22.92,0,0,0-8-1.45C11.83,35.85,0,49.65,0,66.67S11.83,97.5,26.42,97.5l.94,0a77.47,77.47,0,0,0,10.5,22.73h21A46.73,46.73,0,0,1,49.2,93.11a32.74,32.74,0,1,1,47-44.41A32.75,32.75,0,1,1,143.1,93.11a46.66,46.66,0,0,1-9.68,27.09h21a77.47,77.47,0,0,0,10.5-22.73c.32,0,.63,0,.95,0,14.58,0,26.41-13.8,26.41-30.83S180.47,35.85,165.89,35.85ZM24.45,76a82.58,82.58,0,0,0,.48,8.81C18.61,83.74,13.71,76,13.71,66.67c0-10.07,5.69-18.24,12.71-18.24a9,9,0,0,1,2.74.43A79.74,79.74,0,0,0,24.45,76Zm142.92,8.81a80.07,80.07,0,0,0-4.23-35.93,9.13,9.13,0,0,1,2.75-.43c7,0,12.7,8.17,12.7,18.24C178.59,76,173.69,83.74,167.37,84.79Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M67.88,114.43l3.65-4.77c7.23,5.54,13,8.35,24.69,8.35s17.35-2.78,24.57-8.25l3.62,4.78a52.44,52.44,0,0,1-8.92,5.66h17.93a46.66,46.66,0,0,0,9.68-27.09A32.74,32.74,0,1,0,96.15,48.7,32.74,32.74,0,1,0,49.2,93.11a46.73,46.73,0,0,0,9.68,27.09H77A51.74,51.74,0,0,1,67.88,114.43Zm55-62.34a14,14,0,0,1,6,1.35,7.73,7.73,0,0,0,8,13.21,14,14,0,1,1-14-14.56ZM105.15,89.65c2.87,0,5.19,1.42,5.19,3.18S108,96,105.15,96,100,94.59,100,92.83,102.29,89.65,105.15,89.65ZM92.33,92.83C92.33,94.59,90,96,87.15,96S82,94.59,82,92.83s2.33-3.18,5.19-3.18S92.33,91.07,92.33,92.83ZM57.14,66.09a14,14,0,0,1,20-12.65,7.73,7.73,0,0,0,8,13.21,14,14,0,0,1-28-.56Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M120.79,109.76c-7.22,5.47-13,8.25-24.57,8.25s-17.46-2.81-24.69-8.35l-3.65,4.77A51.74,51.74,0,0,0,77,120.2h38.48a52.44,52.44,0,0,0,8.92-5.66Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnfollowmonkey);
export default __webpack_public_path__ + "static/media/unfollowmonkey.93bd1314157ac2e6723e64af485ae9b7.svg";
export { ForwardRef as ReactComponent };